import React, { Fragment, useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import "./schedule.scss";
import { components } from 'react-select';
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { getStudentFacultyList, getStudentSchedule, getStudentSubjectList } from "../../Redux/ActionCreators/scheduleAction";
import { convertDate, formatTimeTo12Hour } from "../../utils/miscelleneous";
import { TopicLoader } from "../../Loader/loader";
import "react-datepicker/dist/react-datepicker.css";

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};

function StudentSchedule() {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [faculty, setFaculty] = useState(null);
    const [subject, setSubject] = useState(null);
    const [facultyId, setFacultyId] = useState('');
    const [subjectId, setSubjectId] = useState('');
    const [date, setDate] = useState(new Date());

    const dispatch = useDispatch();
    const timerRef = useRef(null);

    const { studentScheduleList, isStudentListLoading, studentSchedulePagination, studentSubjectList, studentFacultyList } = useSelector((state) => state.schedule);
    useEffect(() => {
        async function firstRender(){
            dispatch(getStudentSchedule(search, date, facultyId, subjectId, page, size));
            dispatch(getStudentFacultyList());
            dispatch(getStudentSubjectList());
        }
        firstRender();
    }, []);

    const searchStudent = (val) => {
        clearTimeout(timerRef.current);
        setSearch(val);
        timerRef.current = setTimeout(() => dispatch(getStudentSchedule(val, date, facultyId, subjectId, page, size)), 800)
    }

    const selectFaculty = async (selectedOption,) => {
        setFaculty(selectedOption);
        setFacultyId(selectedOption?.value || '');
        dispatch(getStudentSchedule( search, date, selectedOption?.value || '', subjectId, page, size));
    }

    const selectSubject = async (selectedOption,) => {
        setSubject(selectedOption);
        setSubjectId(selectedOption?.value || '');
        dispatch(getStudentSchedule(search, date, facultyId, selectedOption?.value || '', page, size));
    }
    
    const selectDate = (e) => {
        setDate(e || '');
        dispatch(getStudentSchedule(search, e || '', facultyId, subjectId, page, size));
    }

    const handleSizeChange = (size) => {
        setSize(size);
        dispatch(getStudentSchedule( search, date, facultyId, subjectId, page, size));
    }

    const prevPage = () => {
        setPage(page - 1);
        dispatch(getStudentSchedule(search, date, facultyId, subjectId, page - 1, size));
    }

    const nextPage = () => {
        setPage(page + 1);
        dispatch(getStudentSchedule(search, date, facultyId, subjectId, page + 1, size));
    }

    return (
         <Fragment>
            <div className='schedule-container'>
                <h3>Class Schedule</h3>
                <div className='schedule-header align-items-end'>
                    <div className="has-search" style={{width: '20%'}}>
                        <span className="form-control-feedback">
                            <img src="/images/search1.svg" width="14" alt='' />
                        </span>
                        <input type='search' name='student' placeholder='Search' value={search} id='search' onChange={(e) => searchStudent(e.target.value)} autoComplete='off' className='form-control' />
                    </div>
                    <div style={{width: '20%'}}>
                        <label>Faculty :</label>
                        <Select
                            options={studentFacultyList}
                            value={faculty}
                            onChange={selectFaculty}
                            placeholder="Select Faculty"
                            components={{ DropdownIndicator }}
                            isClearable
                        />
                    </div>
                    <div style={{width: '20%'}}>
                        <label>Subject :</label>
                        <Select
                            options={studentSubjectList}
                            value={subject}
                            onChange={selectSubject}
                            placeholder="Select Subject"
                            components={{ DropdownIndicator }}
                            isClearable
                        />
                    </div>
                    <div style={{width: '20%'}}>
                        <label htmlFor='date'>Date :</label>
                        <DatePicker
                            selected={date ? new Date(date) : null}
                            onChange={(date) => selectDate(date)}
                            dateFormat="yyyy-MM-dd"
                            placeholderText="Select Date"
                            className="form-control mt-2"
                            dropdownMode="select"
                            isClearable
                        />
                    </div>
                </div>
                {
                isStudentListLoading ?
                    <div>
                        <TopicLoader />
                    </div>
                    :
                    <div className="table-admin" 
                    style={{ marginTop: studentScheduleList?.length === 0 ? -43 : -60 }}
                    >
                        <Table responsive style={{ overflow: 'hidden' }}>
                            <thead>
                                <tr className="header-table">
                                    <th style={{ width: '15%' }}>Subject</th>
                                    <th style={{ width: '15%' }}>Class Name</th>
                                    <th style={{ width: '15%' }}>Chapter</th>
                                    <th style={{ width: '10%' }}>Date & Time</th>
                                    <th style={{ width: '15%' }}>Faculty</th>
                                    <th style={{ width: '10%' }}>Attendance</th>
                                    <th style={{ width: '10%' }}>Class Type</th>
                                    <th style={{ width: '15%' }}>Class URL</th>
                                </tr>
                                <hr />
                            </thead>
                            <tbody className="table-body" >
                                {
                                    (studentScheduleList !== "" && studentScheduleList !== undefined && studentScheduleList.length > 0 ?
                                        studentScheduleList.map((schedule, i) => {
                                            return (
                                                <tr key={i} 
                                                // style={{ borderTop: i === 0 ? (selectedProgram !== null || selectedSubject !== null || selectedBatch !== null || selectedFaculty !== null || selectedStatus !== '') ? '65px solid #F7F7FA' : '15px solid #F7F7FA' : null }}
                                                >
                                                    <td style={{ width: '15%' }} className='text-center'>{schedule?.subject?.name}</td>
                                                    <td style={{ width: '15%' }} className='text-center'>{schedule?.title}</td>
                                                    <td style={{ width: '15%' }} className='text-center'>{schedule?.chapter?.name}</td>
                                                    <td style={{ width: '10%' }} className='text-center'>
                                                        {convertDate(schedule?.date)}
                                                        <br />
                                                        {formatTimeTo12Hour(schedule?.from)} - {formatTimeTo12Hour(schedule?.to)}
                                                    </td>
                                                    <td style={{ width: '15%' }} className='text-center'>{schedule?.faculty ? schedule?.faculty?.firstname + ' ' + schedule?.faculty?.lastname : '-'}</td>
                                                    <td style={{ width: '10%' }} className='text-center'>{schedule?.is_present || '-'}</td>
                                                    <td style={{ width: '10%' }} className='text-center'>{schedule?.class_type}</td>
                                                    {/* <td style={{ width: '10%', textOverflow: 'ellipsis' }} title={schedule.class_url}>{schedule?.class_url}</td> */}
                                                    <td style={{ width: '15%' }}>
                                                        {schedule?.class_url ? (
                                                            <span 
                                                                title={schedule.class_url}
                                                                style={{
                                                                    display: 'inline-block',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                {schedule.class_url.substring(0, 18) + '...'}
                                                            </span>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr 
                                        style={{ borderTop: '35px solid #F7F7FA' }}>
                                            <td colSpan={7}>
                                                <div className='empty-list'>
                                                    <img src='/images/empty.png' alt='' />
                                                </div>
                                            </td>
                                        </tr>)
                                }
                            </tbody>
                        </Table>
                    </div>
                }
                {
                    studentSchedulePagination !== undefined && studentSchedulePagination.totalPages > 1 && 
                    <div className='d-flex align-items-center justify-content-between' style={{ marginTop: (studentScheduleList?.length < 1 ? 315 : 25) }}>
                        <div className='schedule-pagination' 
                            style={{ marginTop: (studentScheduleList?.length < 1 ? 315 : 25) }}>
                            {
                                page === 1 ?
                                    <img src='/images/page_prev_disable.svg' alt='' />
                                    : <img src='/images/page_prev_active.svg' onClick={prevPage} alt='' />
                            }
                            &nbsp;&nbsp;
                            <div>Page&nbsp;&nbsp; <input value={page} readOnly />&nbsp;of {studentSchedulePagination?.totalPages}</div>&nbsp;
                            {
                                page === studentSchedulePagination?.totalPages ?
                                    <img src='/images/page_next_disable.svg' alt='' /> :
                                    <img src='/images/page_next_active.svg' onClick={nextPage} alt='' />
                            }
                        </div>
                        <div className='d-flex align-items-center justify-content-end' style={{ width: studentSchedulePagination !== undefined && studentSchedulePagination.totalPages > 1 ? '20%' : '100%' }}>
                            <select style={{ width: '20%' }} className='form-control' value={size} onChange={(e) => handleSizeChange(e.target.value)}>
                                <option>10</option>
                                <option>20</option>
                                <option>30</option>
                                <option>40</option>
                            </select> &nbsp;
                            <p>Items per page</p>
                        </div>
                    </div>
                }
            </div>
        </Fragment>
    );
}

export default StudentSchedule;
